import { AccountsApiBase } from '@/libs/apis/accounts/base';

export class InviteAccountsApi extends AccountsApiBase {
  referencing(email) {
    const data = { email };
    return super.post('invite/referencing/', data);
  }
}
